import { CreateUser } from '@/types/user';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function user(axios: any) {
  async function getMe() {
    try {
      const response = await axios.get('/api/auth/me');
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/users] getMe Error', e);
    }
    return null;
  }

  async function getUsers(filter: any) {
    try {
      const response = await axios.get(`/api/users?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response;
      }
    } catch (e) {
      console.error('[api/users] getUsers Error', e);
    }
    return null;
  }

  async function getUser(id: number) {
    try {
      const response = await axios.get(`/api/users/${id}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/users] getMaterials Error', e);
    }
    return 0;
  }

  async function createUser(payload: CreateUser) {
    const response = await axios.post('/api/users', payload);
    try {
      if (response.status === 200) {
        return true;
      }
    } catch (e) {
      console.error('[api/users] createUser Error', e);
    }
    return null;
  }

  async function updateUser(id: number, payload: CreateUser) {
    const response = await axios.put(`/api/users/${id}`, (payload));
    try {
      if (response.status === 200) {
        return true;
      }
    } catch (e) {
      console.error('[api/users] updateUser Error', e);
    }
    return null;
  }

  async function deleteUser(id: number) {
    const response = await axios.delete(`/api/users/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/users] deleteUser Error', e);
    }
    return null;
  }

  async function deleteSelfSignature() {
    const response = await axios.delete('/api/delete-signature');
    try {
      if (response.status === 404) {
        return '';
      }
    } catch (e) {
      console.error('[api/users] deleteSelfSignature Error', e);
    }
    return null;
  }

  async function deleteSignature(id: number) {
    const response = await axios.delete(`/api/users/${id}/signature`);
    try {
      if (response.status === 404) {
        return '';
      }
    } catch (e) {
      console.error('[api/users] deleteSignature Error', e);
    }
    return null;
  }

  const checkInformationExists = async (payload: any) => {
    const axiosResult = await axios.post('/api/users/checkInfo', payload);
    if (axiosResult.status === 200) {
      return axiosResult.data;
    }
    return {
      email: 'failed',
      telephone: 'failed',
    };
  };

  return {
    getMe,
    getUsers,
    getUser,
    createUser,
    updateUser,
    deleteUser,
    deleteSelfSignature,
    deleteSignature,
    checkInformationExists,
  };
}
